import Vue from 'vue'
import Router from 'vue-router'
import Guide from '@/views/guide'
import Login from '@/views/login'
import SetPassword from '@/views/set-password'
import IndustryInfo from '@/views/industry-info'
import Baseinfo from '@/views/baseinfo'
import RegisterResults from '@/views/register-results'
import ApplyPackage  from '@/views/apply-package'
import Agreement from '@/views/agreement'
import Payment from '@/views/payment'
import BaseinfoAuth from '@/views/baseinfo-auth'
import ApplyResults  from '@/views/apply-results'
import StoreList from '@/views/store-list'
import ApplyPassed from '@/views/apply-passed'
import PaySuccess from '@/views/pay/success'
import RegisterMP from '@/views/register-mp'
import RegisterBase from '@/views/register-base'
import SetIndustry from '@/views/set-industry'
import SetAuth from '@/views/set-auth'
import Pay from '@/views/pay/index'
import GetAppID from '@/views/appId'
import Auth from '@/views/auth'
import AuthSuccess from '@/views/auth-succes'
import Result from '@/views/result'
import DownloadPage from '@/views/download-page'
import LeaseType from '@/views/lease-type'
import MerchantRatio from '@/views/merchantRatio'
import MarketRatio from '@/views/marketRatio'
import Filing from '@/views/filing'
import FilingSuccess from '@/views/filing-success'

// 分销相关页面
import DistributionGuide from '@/views/distribution/guide'
import DistributionLogin from '@/views/distribution/login'
import DistributionSetPassword from '@/views/distribution/set-password'
import DistributionBaseinfo from '@/views/distribution/baseinfo'
import DistributionApplyPackage  from '@/views/distribution/apply-package'
import DistributionAgreement from '@/views/distribution/agreement'
import DistributionPayment from '@/views/distribution/payment'
import DistributionBaseinfoAuth from '@/views/distribution/baseinfo-auth'
import DistributionApplyResults  from '@/views/distribution/apply-results'
import DistributionQualifList from '@/views/distribution/qualifications-list'
import DistributionPaySuccess from '@/views/distribution/pay-success'
import DistributionPay from '@/views/distribution/pay'
import DistributionDownloadPage from '@/views/distribution/download-page'


Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
      meta: {
        requireAuth: true,
        title:"注册引导"
      }
    },{
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        requireAuth: true,
        title:"注册引导"
      }
    },{
      path: '/set-password',
      name: 'set-password',
      component: SetPassword,
      meta:{title:"注册引导"}
    },{
      path: '/guide',
      name: 'Guide',
      component: Guide,
      meta:{title:"注册引导"}
    },{
      path: '/store-list',
      name: 'StoreList',
      component: StoreList,
      meta:{title:"注册引导"}
    },{
      path: '/industry-info',
      name: 'IndustryInfo',
      component: IndustryInfo,
      meta:{title:"注册引导"}
    },{
      path: '/baseinfo',
      name: 'Baseinfo',
      component: Baseinfo,
      meta:{title:"注册引导"}
    },{
      path: '/register-results',
      name: 'RegisterResults',
      component: RegisterResults,
      meta:{title:"注册引导"}
    },{
      path: '/apply-package',
      name: 'ApplyPackage',
      component: ApplyPackage,
      meta:{title:"注册引导"}
    },{
      path: '/agreement',
      name: 'Agreement',
      component: Agreement,
      meta:{title:"注册引导"}
    },{
      path: '/payment',
      name: 'Payment',
      component: Payment,
      meta:{title:"注册引导"}
    },{
      path: '/baseinfo-auth',
      name: 'BaseinfoAuth',
      component: BaseinfoAuth,
      meta:{title:"注册引导"}
    },{
      path: '/apply-results',
      name: 'ApplyResults',
      component: ApplyResults,
      meta:{title:"注册引导"}
    },{
      path: '/apply-passed',
      name: 'ApplyPassed',
      component: ApplyPassed,
      meta:{title:"注册引导"}
    },{
      path: '/pay/success',
      name: 'PaySuccess',
      component: PaySuccess,
      meta:{title:"注册引导"}
    },{
      path: '/register-mp',
      name: 'RegisterMP',
      component: RegisterMP,
      title:"设置小程序AppID"
    },{
      path: '/register-base',
      name: 'RegisterBase',
      component: RegisterBase,
      title:"设置小程序基本信息"
    },{
      path: '/set-industry',
      name: 'SetIndustry',
      component: SetIndustry,
      meta:{title:"设置行业"}
    },{
      path: '/set-auth',
      name: 'SetAuth',
      component: SetAuth,
      meta:{title:"配置域名授权"}
    },{
      path: '/pay',
      name: 'Pay',
      component: Pay,
      meta:{title:"注册引导"}
    },{
      path: '/appId',
      name: 'GetAppID',
      component: GetAppID,
      meta:{title:"注册引导"}
    },{
      path: '/auth',
      name: 'Auth',
      component: Auth,
      meta:{title:"注册引导"}
    },{
      path: '/result',
      name: 'Result',
      component: Result,
      meta:{title:"注册引导"}
    },{
      path: '/auth-succes',
      name: 'AuthSuccess',
      component: AuthSuccess,
      meta:{title:"注册引导"}
    },{
      path: '/download',
      name: 'DownloadPage',
      component: DownloadPage,
      meta:{title:"下载应用"}
    },{
      path: '/lease-type',
      name: 'LeaseType',
      component: LeaseType,
      meta:{title:"选择所属类型"}
    },{
      path: '/merchant-ratio',
      name: 'MerchantRatio',
      component: MerchantRatio,
      meta:{title:"商家比例"}
    },{
      path: '/market-ratio',
      name: 'MarketRatio',
      component: MarketRatio,
      meta:{title:"市场人员比例"}
    },{
      path: '/filing',
      name: 'Filing',
      component: Filing,
      meta:{title:"小程序备案"}
    },{
      path: '/filing-success',
      name: 'FilingSuccess',
      component: FilingSuccess,
      meta:{title:"注册引导"}
    },
    //////// 分销入驻路由地址
    {
      path: '/distribution/login',
      name: 'Login',
      component: DistributionLogin,
      meta: {
        requireAuth: true,
        title:"注册引导"
      }
    },{
      path: '/distribution/set-password',
      name: 'set-password',
      component: DistributionSetPassword,
      meta:{title:"注册引导"}
    },{
      path: '/distribution/guide',
      name: 'Guide',
      component: DistributionGuide,
      meta:{title:"注册引导"}
    },{
      path: '/distribution/qualifications-list',
      name: 'StoreList',
      component: DistributionQualifList,
      meta:{title:"注册引导"}
    },{
      path: '/distribution/baseinfo',
      name: 'Baseinfo',
      component: DistributionBaseinfo,
      meta:{title:"注册引导"}
    },{
      path: '/distribution/apply-package',
      name: 'ApplyPackage',
      component: DistributionApplyPackage,
      meta:{title:"注册引导"}
    },{
      path: '/distribution/agreement',
      name: 'Agreement',
      component: DistributionAgreement,
      meta:{title:"注册引导"}
    },{
      path: '/distribution/payment',
      name: 'Payment',
      component: DistributionPayment,
      meta:{title:"注册引导"}
    },{
      path: '/distribution/baseinfo-auth',
      name: 'BaseinfoAuth',
      component: DistributionBaseinfoAuth,
      meta:{title:"注册引导"}
    },{
      path: '/distribution/apply-results',
      name: 'ApplyResults',
      component: DistributionApplyResults,
      meta:{title:"注册引导"}
    },{
      path: '/distribution/pay/success',
      name: 'PaySuccess',
      component: DistributionPaySuccess,
      meta:{title:"注册引导"}
    },{
      path: '/distribution/pay',
      name: 'Pay',
      component: DistributionPay,
      meta:{title:"注册引导"}
    },{
      path: '/distribution/download',
      name: 'DownloadPage',
      component: DistributionDownloadPage,
      meta:{title:"注册引导"}
    },
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js